import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import AirlineImg from 'components/AirlineLogo';

export const FlightDetailCardRoot = styled.div`
  display: flex;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 6px 10px 0 rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16);
  width: 100%;
  flex-direction: column;
  border: 1px solid ${ColorPalette.HEX.Platinum2};
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const AirlineWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const AirlineLogo = styled(AirlineImg)`
  width: 24px;
`;

export const AirlineName = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  margin-left: 8px;
`;

export const OperatorName = styled.span`
  font-size: 12px;
  color: ${ColorPalette.HEX.DimGray2};
  margin-top: 2px;
`;

export const FlightNumber = styled.div`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 12px;
`;

export const Body = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
`;

export const DepartureWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DepartureRouteTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const DepartureAirportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`;

export const ArrivalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ArrivalRouteTypeWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`;

export const ArrivalAirportWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  align-items: flex-end;
`;

export const RouteTypeLabel = styled.span`
  color: ${ColorPalette.HEX.PineTree};
  font-size: 12px;
`;

export const Date = styled.span`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 12px;
`;

export const Time = styled.span`
  font-size: 24px;
  font-weight: 600;
  color: ${ColorPalette.HEX.PineTree};
  margin-top: 8px;
`;

export const Airport = styled.span`
  font-size: 16px;
  fontweight: 600;
  color: ${ColorPalette.HEX.PineTree};
`;

export const CityName = styled.span`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 12px;
`;

export const AirportName = styled.span`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 10px;
  margin-top: 4px;
`;

export const FlightLineContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
  width: 40%;
`;

export const FlightLineTopText = styled.span`
  color: ${ColorPalette.HEX.PineTree};
  font-size: 12px;
  line-height: 14px;
  margin: 5px 0;
`;

export const FlightLineBottomText = styled.span`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 10px;

  & > span {
    text-transform: capitalize;
  }
`;

export const FlightLineBottomTextStrong = styled.span`
  color: ${ColorPalette.HEX.DimGray2};
  font-size: 12px;
  font-weight: bold;

  & > span {
    text-transform: capitalize;
  }
`;

export const FlightLine = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin: 5px 0;
  width: 100%;
  height: 2px;
  background: ${({ theme }) => theme.flightLine.line};

  &:before,
  &:after {
    content: '';
    height: 4px;
    width: 4px;
    border-radius: 4px;
    background: ${ColorPalette.HEX.White};
    border: 2px solid ${({ theme }) => theme.flightLine.point};
  }
`;
